import styled from "styled-components";

const StyledInstructor = styled.div`
    display: flex;
    justify-content: center;
`

export default StyledInstructor;